import { ISbRichtext } from '@storyblok/react';
import { useMemo } from 'react';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';
import { IProductInfo } from './types';

export const useProductDetailInfo = (): IProductInfo => {
  const { productDetail } = useSiteConfig();
  const productInfo: IProductInfo = useMemo(() => {
    const warrantyInfoTitle = productDetail?.warrantyInfoTitle;
    const warrantyInfoText = productDetail?.warrantyInfoText as ISbRichtext;
    const priceLink = productDetail?.priceLink;

    return {
      warrantyInfoTitle,
      warrantyInfoText,
      priceLink,
    };
  }, [productDetail]);

  return productInfo;
};
